// Components
import BodyTop from "./BodyTop/BodyTop";
import Memberships from "./Memberships/Memberships";

// Styles
import body_styles from "./body_styles";

function Body({ refresh }: { refresh: () => void }) {
  return (
    <div style={body_styles.body}>
      <BodyTop />
      <Memberships refresh={refresh} />
    </div>
  );
}

export default Body;